import { render, staticRenderFns } from "./MultiChoiceCardDialog.vue?vue&type=template&id=036c9527&"
import script from "./MultiChoiceCardDialog.vue?vue&type=script&lang=ts&"
export * from "./MultiChoiceCardDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MultiChoiceCardDialog.vue?vue&type=style&index=0&id=036c9527&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports